import { useLanguage } from '../utils/LanguageContext';
import { ItemView } from './common/CommonComponents';
import { Language } from '../shared/constants/userConstants.js';
import { useAuth } from '../utils/AuthContext.js';

const languagePreferenceItem = (languagePreference, langForEnum) => ({
  field: 'languagePreference',
  value: languagePreference && langForEnum(Language, languagePreference),
});

const LanguagePreferenceView = () => {
  const { langForEnum } = useLanguage();
  const { user } = useAuth();

  const items = [languagePreferenceItem(user.languagePreference, langForEnum)];

  return <ItemView items={items} />;
};

export { languagePreferenceItem };
export default LanguagePreferenceView;
